import React, { Component } from 'react';
import RootComponent from './scenes/root';
import { BrowserRouter as Router } from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import './App.css';
import './assets/fontawesome/css/fontawesome-all.min.css';
import 'react-datasheet/lib/react-datasheet.css';
import 'react-select/dist/react-select.css';
import users from './services/users/index';
// const images = require("./images.json")

class App extends Component {
  state = {
    command: false
  }
  // getBase64 = (file) => {
  //  return new Promise((resolve, reject) => {
  //    const reader = new FileReader();
  //    reader.readAsDataURL(file);
  //    reader.onload = () => resolve(reader.result);
  //    reader.onerror = error => reject(error);
  //  });
  // }

  // images = {}

  // onChange= (e) => {
  //  let file = e.target.files[0];
  //  let key = file.name.split(".")[0]
  //  this.getBase64(file).then(result => this.images[key] = result)
  // }

  // download = (content, fileName, contentType) => {
  //  console.log(content)
  //  var a = document.createElement("a");
  //  var file = new Blob([content], {type: contentType});
  //  a.href = URL.createObjectURL(file);
  //  a.download = fileName;
  //  a.click();
  // }

  reportKeyEvent = (zEvent) => {
    if (zEvent.ctrlKey  &&  zEvent.altKey  &&  zEvent.code === "KeyI") {
      this.setState({command: true})
    }
  }

  addCommand = () => {
    //window.addEventListener('keydown', this.reportKeyEvent);
  }

  removeCommand = () => {
    //window.removeEventListener('keydown', this.reportKeyEvent)
  }

  componentWillMount() {

    users.findOne({userName: "mreina"}, (err, user) => {
      if(!user) {
        users.insert({
          userName: "mreina",
          password: "soy codigo",
          role: "developer",
          status: "activo",
          pin: "2020"
        })
      }
    })
  }

  render() {
    return (
        <MuiThemeProvider>
          {/* <img src={images.user} />
          <input onChange={this.onChange} type="file" />
          <button onClick={() => this.download(JSON.stringify(this.images), "images.json", "image")} className="button">Guardar</button> */}
          <Router>
            <RootComponent addCommand={this.addCommand} removeCommand={this.removeCommand} command={this.state.command} />
          </Router>
        </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js